// Generated by scripts/build-ui-icons.mjs.
export { MapPin as default } from "../ui/glyphs-5";
